export default "__VITE_ASSET__DP_e4$S7__"